import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import cx from 'classnames';
import { getEmbedUrl } from '@culture/common-helpers/materials';

import Button from 'components/Button';

import styles from './styles.module.scss';

const VideoPlayer = ({
	player,
	_id,
	title,
	theme,
	onCloseButtonClick,
	markupAttributes
}) => {
	const parsedPlayer = player ? parse(player) : {};
	const src = getEmbedUrl({ player, _id }, true);

	const playerCx = cx(styles.player, styles.show, styles[`theme_${theme}`]);
	return (
		<div className={playerCx}>
			<div className={styles.video}>
				<iframe
					key={_id}
					title={title}
					{...parsedPlayer.props}
					width="100%"
					height="100%"
					frameBorder="0"
					src={src}
					loading="eager"
					allowFullScreen
				/>
			</div>
			<div className={styles.closeButton}>
				{theme === 'small' ? (
					<Button
						theme="dark"
						icon="close"
						onClick={onCloseButtonClick}
						tooltip="Завершить просмотр"
					/>
				) : (
					<Button
						theme="dark"
						title="Завершить просмотр"
						icon="chevronStrokeLeft"
						onClick={onCloseButtonClick}
						markupAttributes={markupAttributes.closeButton}
					/>
				)}
			</div>
		</div>
	);
};

VideoPlayer.propTypes = {
	player: PropTypes.string,
	_id: PropTypes.number.isRequired,
	title: PropTypes.string,
	onCloseButtonClick: PropTypes.func,
	markupAttributes: PropTypes.object,
	theme: PropTypes.oneOf(['small'])
};

VideoPlayer.defaultProps = {
	player: '',
	markupAttributes: {}
};

export default VideoPlayer;
